"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var performance_model_1 = require("./model/performance.model");
var performance_measure_model_1 = require("./model/performance-measure.model");
var core_1 = require("@angular/core");
var path_helper_1 = require("./config/path.helper");
var measure_enum_1 = require("./enum/measure.enum");
var from_1 = require("rxjs/observable/from");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var HttpPerformanceCalculationService = /** @class */ (function () {
    function HttpPerformanceCalculationService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.meReportingServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(path_helper_1.PathHelper.meReportingServiceUriKey));
    }
    HttpPerformanceCalculationService_1 = HttpPerformanceCalculationService;
    HttpPerformanceCalculationService.prototype.getFItemPerformance = function (level, itemId, languageId, systemName, iFSystemName, iFItemId) {
        var achievement$ = this.post(level, itemId, languageId, measure_enum_1.Measure.OLD_ACHIEVEMENT.valueOf(), null, null, systemName, iFSystemName, iFItemId);
        var progress$ = this.post(level, itemId, languageId, measure_enum_1.Measure.GROWTH_IN_PERCENT.valueOf(), null, null, systemName, iFSystemName, iFItemId);
        return zip_1.zip(achievement$, progress$).pipe(operators_1.map(function (value) {
            return new performance_model_1.Performance(HttpPerformanceCalculationService_1.getAvg(value[0], measure_enum_1.Measure.OLD_ACHIEVEMENT.valueOf()), HttpPerformanceCalculationService_1.getAvg(value[1], measure_enum_1.Measure.GROWTH_IN_PERCENT.valueOf()));
        }));
    };
    HttpPerformanceCalculationService.prototype.getIndicatorPerformance = function (level, itemId, indicatorId, languageId, period, systemName, iFSystemName, iFItemId) {
        var actual$ = this.post(level, itemId, languageId, measure_enum_1.Measure.ACTUAL.valueOf(), indicatorId, period, systemName, iFSystemName, iFItemId);
        var target$ = this.post(level, itemId, languageId, measure_enum_1.Measure.TARGET.valueOf(), indicatorId, period, systemName, iFSystemName, iFItemId);
        var achievement$ = this.post(level, itemId, languageId, measure_enum_1.Measure.OLD_ACHIEVEMENT.valueOf(), indicatorId, period, systemName, iFSystemName, iFItemId);
        var progress$ = this.post(level, itemId, languageId, measure_enum_1.Measure.GROWTH_IN_PERCENT.valueOf(), indicatorId, period, systemName, iFSystemName, iFItemId);
        return zip_1.zip(actual$, target$, achievement$, progress$).pipe(operators_1.map(function (value) {
            return new performance_measure_model_1.PerformanceMeasure(HttpPerformanceCalculationService_1.getData(value[0], measure_enum_1.Measure.ACTUAL.valueOf()), HttpPerformanceCalculationService_1.getData(value[1], measure_enum_1.Measure.TARGET.valueOf()), HttpPerformanceCalculationService_1.getData(value[2], measure_enum_1.Measure.OLD_ACHIEVEMENT.valueOf()), HttpPerformanceCalculationService_1.getData(value[3], measure_enum_1.Measure.GROWTH_IN_PERCENT.valueOf()));
        }));
    };
    HttpPerformanceCalculationService.prototype.getIndicatorMeasurePerformance = function (level, itemId, indicatorId, measure, languageId, period, systemName, iFSystemName, iFItemId) {
        var value$ = this.post(level, itemId, languageId, measure.valueOf(), indicatorId, period, systemName, iFSystemName, iFItemId);
        return value$.pipe(operators_1.map(function (value) { return HttpPerformanceCalculationService_1.getData(value, measure.valueOf()); }));
    };
    HttpPerformanceCalculationService.prototype.post = function (level, itemId, languageId, measure, indicatorId, period, systemName, iFSystemName, iFItemId) {
        var _this = this;
        return this.meReportingServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + "/report", HttpPerformanceCalculationService_1.getMetaData(level, itemId, languageId, measure, indicatorId, period, systemName, iFSystemName, iFItemId)); }));
    };
    HttpPerformanceCalculationService.getAvg = function (response, measure) {
        var measureIndex = HttpPerformanceCalculationService_1.findIndex(response.metadata, measure);
        if (measureIndex == -1)
            return null;
        var notNullValues = [];
        for (var _i = 0, _a = response.data; _i < _a.length; _i++) {
            var row = _a[_i];
            var value = row[measureIndex];
            if (value != null)
                notNullValues.push(value);
        }
        if (notNullValues.length == 0)
            return null;
        return notNullValues.reduce(function (sum, current) { return sum + current; }, 0) / notNullValues.length;
    };
    HttpPerformanceCalculationService.getData = function (response, measure) {
        var measureIndex = HttpPerformanceCalculationService_1.findIndex(response.metadata, measure);
        if (measureIndex == -1)
            return null;
        var notNullValues = [];
        for (var _i = 0, _a = response.data; _i < _a.length; _i++) {
            var row = _a[_i];
            var value = row[measureIndex];
            if (value != null)
                notNullValues.push(value);
        }
        if (notNullValues.length != 1)
            return null; //TODO remove after fix
        return response.data[0][measureIndex];
    };
    HttpPerformanceCalculationService.getMetaData = function (level, itemId, languageId, measure, indicatorId, period, systemName, iFSystemName, iFItemId) {
        var obj = {
            "categorySystemNames": [],
            "measureSystemName": measure,
            "filters": {
                "rootOperator": {
                    "type": "operator",
                    "operator": "and",
                    "children": []
                }
            },
            "showIndicatorDisaggregations": false,
            "fetchNames": false,
            "languageId": languageId
        };
        if (iFSystemName) {
            obj.categorySystemNames.push(iFSystemName);
            obj.filters.rootOperator.children.push(HttpPerformanceCalculationService_1.getFilter(iFSystemName, iFItemId));
        }
        var name = systemName ? systemName : "RFLevel" + level;
        obj.categorySystemNames.push(name);
        obj.filters.rootOperator.children.push(HttpPerformanceCalculationService_1.getFilter(name, itemId));
        if (period) {
            obj.categorySystemNames.push("Year");
            obj.filters.rootOperator.children.push(HttpPerformanceCalculationService_1.getFilter('Year', period));
        }
        obj.categorySystemNames.push('Indicator');
        if (indicatorId) {
            obj.filters.rootOperator.children.push(HttpPerformanceCalculationService_1.getFilter('Indicator', indicatorId));
        }
        return obj;
    };
    HttpPerformanceCalculationService.getFilter = function (onCategory, id) {
        return {
            "type": "filter",
            "filterType": "in",
            "excluded": false,
            "isHiddenForUser": false,
            "onCategory": onCategory,
            "values": [
                id
            ]
        };
    };
    HttpPerformanceCalculationService.findIndex = function (metadata, measure) {
        if (!metadata || metadata.length == 0)
            return -1;
        for (var i = 0; i < metadata.length; i++) {
            if (metadata[i].systemName === measure) {
                return i;
            }
        }
        return -1;
    };
    HttpPerformanceCalculationService = HttpPerformanceCalculationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpPerformanceCalculationService);
    return HttpPerformanceCalculationService;
    var HttpPerformanceCalculationService_1;
}());
exports.HttpPerformanceCalculationService = HttpPerformanceCalculationService;
//# sourceMappingURL=http-performance-calculation.service.js.map